"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageManagementFunctionCall = exports.nonFungibleTokenFunctionCall = exports.fungibleTokenFunctionCall = void 0;
const Amount_1 = require("./Amount");
const Gas_1 = require("./Gas");
function fungibleTokenFunctionCall(functionCall) {
    const transfer = (options) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'ft_transfer',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    const transfer_call = (options) => {
        const { args, gas = Gas_1.Gas.parse(50, 'T') } = options;
        return functionCall({
            methodName: 'ft_transfer_call',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    return { transfer, transfer_call };
}
exports.fungibleTokenFunctionCall = fungibleTokenFunctionCall;
function nonFungibleTokenFunctionCall(functionCall) {
    const transfer = (options) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'nft_transfer',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    const transfer_call = (options) => {
        const { args, gas = Gas_1.Gas.parse(50, 'T') } = options;
        return functionCall({
            methodName: 'nft_transfer_call',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    const approve = (options) => {
        const { args, attachedDeposit = Amount_1.Amount.parse('0.005', 'NEAR'), gas } = options;
        return functionCall({
            methodName: 'nft_approve',
            args,
            attachedDeposit,
            gas,
        });
    };
    const revoke = (options) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'nft_revoke',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    const revoke_all = (options) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'nft_revoke_all',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    return { transfer, transfer_call, approve, revoke, revoke_all };
}
exports.nonFungibleTokenFunctionCall = nonFungibleTokenFunctionCall;
function storageManagementFunctionCall(functionCall) {
    const deposit = (options) => {
        const { args, attachedDeposit, gas } = options;
        return functionCall({
            methodName: 'storage_deposit',
            args,
            attachedDeposit,
            gas,
        });
    };
    const withdraw = (options = {}) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'storage_withdraw',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    const unregister = (options = {}) => {
        const { args, gas } = options;
        return functionCall({
            methodName: 'storage_unregister',
            args,
            attachedDeposit: Amount_1.Amount.ONE_YOCTO,
            gas,
        });
    };
    return { deposit, withdraw, unregister };
}
exports.storageManagementFunctionCall = storageManagementFunctionCall;
//# sourceMappingURL=function-call.js.map